



























import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class AccountValidationPage extends Vue {
  @Prop([Boolean])
  public status: boolean;
}
